module.exports = __webpack_public_path__ + "static/dbw-a5b97a209433f31074ca9274e682cf70.png";